module.exports = __webpack_public_path__ + "img/technologyImg3.3348ef67.png";